module.exports = __webpack_public_path__ + "img/cl.88a419c0.svg";